module.exports = __webpack_public_path__ + "static/media/microsoft-icon.f32b3f89.svg";